import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

import Navigation from "../../components/navigation/Navigation";
import Banner from "../../components/banner/banner";
import Footer from "../../components/footer/Footer";
import "./update.css";
import "../../App.css";
import updateBackground from "../../assets/images/update-background.png";

const UpdatePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Elverve Expands to Brookfields | AI CoE Launch";
  }, []);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <Navigation show={show} onClose={handleClose} onShow={handleShow} />

      <Banner
        className="update-banner"
        title={
          <span style={{ display: "inline-block", marginTop: "60px" }}>
            Accelerating Your AI Roadmap
          </span>
        }
        bg={updateBackground}
      />

      <Container className="mt-75 mb-10">
        <Row>
          <Col>
            <h1 className="main-title text-left">
              Elverve Expands to Coimbatore
            </h1>

            <p className="mt-3 about_content text-left">
              <strong>We are officially live.</strong> On{" "}
              <strong>January 17, 2026</strong>, Elverve marked a major
              milestone in our mission to drive enterprise autonomy with the
              inauguration of our new{" "}
              <strong>AI Center of Excellence (CoE)</strong> in Brookfields,
              Coimbatore.
            </p>

            <p className="about_content text-left">
              As demand for our <strong>Agentic AI</strong> and{" "}
              <strong>Digital Transformation</strong> solutions grows, so does
              the need for a world-class delivery infrastructure. This new
              facility is our answer.
            </p>

            <h1 className="main-title text-left mt-60">
              Not Just an Office. A Delivery Engine.
            </h1>

            <p className="about_content text-left">
              While our headquarters drives strategy, our new Coimbatore CoE is
              the engine room focused on <strong>Applied AI Delivery</strong>.
            </p>

            <p className="about_content text-left">
              We built this center with one specific goal:
            </p>

            <h2 className="mt-3">Your Success.</h2>

            <p className="about_content text-left">
              By expanding our footprint in one of India’s fastest-growing tech
              hubs, we are scaling our ability to support clients with speed,
              reliability, and deep technical expertise.
            </p>

            <h1 className="main-title text-left mt-60">
              What This Means for You
            </h1>

            <ul className="about_content">
              <li>
                <strong>Faster Deployment:</strong> Dedicated squads to
                accelerate the Design-to-Deploy lifecycle for your AI agents.
              </li>
              <li>
                <strong>24/7 Agentic Oversight:</strong> Continuous monitoring,
                optimization, and evolution of autonomous systems.
              </li>
              <li>
                <strong>Expanded Talent Pool:</strong> Immediate access to
                specialists in Python, Generative AI, MLOps, and Cloud-Native
                infrastructure.
              </li>
            </ul>

            <h1 className="main-title text-left mt-60">
              Ready to Build? We Have the Team.
            </h1>

            <p className="about_content text-left">
              The biggest bottleneck in AI adoption today is finding the right
              people to execute the vision.
            </p>

            <p className="about_content text-left">
              With the opening of our Brookfields CoE, we’ve expanded our
              capacity to take on new, complex challenges—whether that’s a
              custom AI Copilot or managing enterprise MLOps pipelines.
            </p>

            <p className="about_content text-left">
              <strong>
                Don’t let resource constraints slow down your innovation.
              </strong>
            </p>

            <div className="mt-4 d-flex gap-3">
              <a
                href="mailto:reachus@elverve.com?subject=Resource%20Consultation%20Request"
                className="newsbutton"
              >
                Book a Resource Consultation
              </a>

              <a
                href="mailto:reachus@elverve.com?subject=Start%20Your%20AI%20Project"
                className="newsbutton"
              >
                Start Your AI Project
              </a>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />
    </div>
  );
};

export default UpdatePage;
